import { render, staticRenderFns } from "./MusicControl.vue?vue&type=template&id=36500511&scoped=true"
import script from "./MusicControl.vue?vue&type=script&lang=js"
export * from "./MusicControl.vue?vue&type=script&lang=js"
import style0 from "./MusicControl.vue?vue&type=style&index=0&id=36500511&prod&lang=less"
import style1 from "./MusicControl.vue?vue&type=style&index=1&id=36500511&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36500511",
  null
  
)

export default component.exports